var map = {
	"./Lancaster-Uni.png": 127,
	"./address_image.svg": 128,
	"./ag_logo.jpeg": 129,
	"./animated_ashutosh.png": 130,
	"./animated_logo.svg": 131,
	"./aw_logo.jpeg": 132,
	"./blogs_image.svg": 133,
	"./bsgc_logo.svg": 134,
	"./cloud_infrastructure.svg": 135,
	"./codeInLogo.png": 136,
	"./coderus_logo.png": 137,
	"./contactMail.png": 138,
	"./coursera_logo.png": 139,
	"./data_science.svg": 140,
	"./db_logo.jpeg": 141,
	"./deeplearning_ai_logo.png": 142,
	"./delhivery_logo.png": 143,
	"./developerActivity.svg": 144,
	"./dsc_logo.png": 145,
	"./education.svg": 146,
	"./experience.svg": 147,
	"./fa-brands-400.svg": 148,
	"./fa-regular-400.svg": 149,
	"./fa-solid-900.svg": 150,
	"./feelingProud.svg": 151,
	"./freecopy_logo.png": 152,
	"./fullstack.svg": 153,
	"./gcp_logo.png": 154,
	"./github_logo.png": 155,
	"./gledus_logo.jpeg": 156,
	"./googleAssistant.jpg": 157,
	"./googleAssistant.svg": 158,
	"./google_logo.png": 159,
	"./ibm_logo.png": 160,
	"./iiitk_logo.png": 161,
	"./intel_logo.jpg": 162,
	"./iss_logo.png": 163,
	"./jsFramework.svg": 164,
	"./lancasteruni.png": 165,
	"./legato_logo.png": 166,
	"./lu-logo2.svg": 167,
	"./lu_logo.png": 168,
	"./lu_logo2.png": 169,
	"./lucareers_logo.png": 170,
	"./magknit_logo.jpeg": 171,
	"./manOnTable.svg": 172,
	"./microsoft_logo.png": 173,
	"./mozilla_logo.png": 174,
	"./muffito_logo.png": 175,
	"./nextuLogo.jpg": 176,
	"./nptel_logo.png": 177,
	"./portfolio.gif": 178,
	"./programmer.svg": 179,
	"./projects_image.svg": 180,
	"./pwa.png": 181,
	"./saayaHealthLogo.png": 182,
	"./scc_logo.jpeg": 183,
	"./sidd_logo.jpeg": 184,
	"./sidd_logo.png": 185,
	"./sidd_logo2.png": 186,
	"./sidd_logo3.png": 187,
	"./sidd_logo4.png": 188,
	"./sidd_logo5.png": 189,
	"./sidd_logo6.png": 190,
	"./siddhi.png": 66,
	"./stanford_logo.png": 191,
	"./talksCardBack.svg": 192,
	"./talksCardBackAlt.svg": 193,
	"./tutorful_logo.png": 194,
	"./ui_ux_design.svg": 195,
	"./unibuddy_logo.png": 196,
	"./wqu.png": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;